import api from "./apiHelper";

export const adviseeBirthday = (payload) => {
  return api.get(`/advisee/advisee-birthday`, payload);
};

export const adviseeStatistic = (year) => {
  return api.get(`/advisee/advisee-statistic?year=${year}`);
};

export const adviseeChart = (year) => {
  return api.get(`/advisee/advisee-statistic-chart?year=${year}`);
};
